<template>
  <div>
    <v-dialog v-model="isDialogVisible" max-width="400">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Plantilla
        </v-card-title>

        <div class="pa-3">
          <section class="">
            <v-form ref="form" v-model="validFormCreate" lazy-validation>
              <v-text-field
                label="Titulo"
                v-model="examTemplate.title"
              ></v-text-field>
            </v-form>
          </section>
        </div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text class="mx-4" @click="isDialogVisible = false">
            Cancelar
          </v-btn>
          <v-btn color="success" :disabled="!validFormCreate" @click="save()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card flat>
      <v-btn dark absolute bottom right fab small @click="showAddDialog()">
        <v-icon aria-label="Agregar plantilla">mdi-plus</v-icon>
      </v-btn>
      <v-container class="fill-height">
        <v-row class="py-4">
          <strong class="text-h5 font-weight-regular px-2"
            >Plantillas de exámenes</strong
          >
        </v-row>
      </v-container>
    </v-card>
    <div class="pa-3">
      <v-list two-line>
        <v-list-item-group active-class="pink--text" multiple>
          <template v-for="(exam, index) of exams">
            <v-list-item :key="index" :to="`templates/${exam.id}`">
              <template v-slot:default="{}">
                <v-list-item-content>
                  <v-list-item-title v-text="exam.title"></v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  Última actualización: {{ exam.lastModifiedDate | datetime }}
                </v-list-item-action>
              </template>
            </v-list-item>

            <v-divider
              v-if="index < exams.length - 1"
              :key="'div' + index"
            ></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import { exam } from "./services/exam";

export default {
  data() {
    return {
      isDialogVisible: false,
      exams: [],
      examTemplate: {},
      validFormCreate: false
    };
  },
  mounted() {
    this.loadExamTemplates();
  },
  methods: {
    showAddDialog() {
      this.isDialogVisible = true;
    },
    loadExamTemplates() {
      exam.findAll().then((response) => (this.exams = response.data.content));
    },
    save() {
      exam
        .create(this.examTemplate)
        .then((r) => {
          console.log(r)
          this.isDialogVisible = false;
        })
        .then(() => this.loadExamTemplates());
    },
  },
};
</script>

<style></style>
